import { create_document_drawer, create_document_row, create_obligation_drawer, create_renewal_drawer } from './onboarding_handoff_utils.js';
import { handover_drawer_catalog } from './onboarding_handoff_handover_drawers.js';

export const handoff_cards = [
  {
    eyebrow: 'OnboardOS',
    title: 'Intake & gates',
    copy: 'Applicant applies. Documents, verification, risk scoring, approvals and signing are collected one time.',
    footer: 'Last sync 38 seconds ago',
    badge: 'Live',
    badge_class: 'bg-success-subtle text-success-emphasis',
    icon: 'bi-clipboard-check',
    icon_class: 'is-blue'
  },
  {
    eyebrow: 'OnboardOS',
    title: 'Activation event',
    copy: 'The case goes live. Its full pack - evidence, controls, risk, approvals and decision - commits to Complyon and the case closes.',
    footer: 'Activation hands over ownership',
    badge: 'Ready',
    badge_class: 'bg-warning-subtle text-warning-emphasis',
    icon: 'bi-send-check',
    icon_class: 'is-purple'
  },
  {
    eyebrow: 'Complyon',
    title: 'Ongoing compliance',
    copy: 'The entity lives here for its compliance lifetime - monitoring, refreshes, payments, audits and re-onboarding triggers.',
    footer: 'Permanent compliance record',
    badge: 'Owned',
    badge_class: 'bg-primary-subtle text-primary-emphasis',
    icon: 'bi-shield-check',
    icon_class: 'is-teal'
  }
];

export const handoff_tabs = [
  { id: 'handovers', label: 'Handovers', count: 6 },
  { id: 'documents_received', label: 'Documents received', count: null },
  { id: 'outstanding_obligations', label: 'Outstanding obligations', count: 5 },
  { id: 'renewal_schedule', label: 'Renewal schedule', count: null },
  { id: 'bridge', label: 'The bridge', count: null }
];

export const handover_metrics = [
  { label: 'Handed over (7 days)', value: '6', note: 'From OnboardOS', accent: 'amber' },
  { label: 'Pending review', value: '3', note: 'Awaiting Complyon acceptance', accent: 'orange' },
  { label: 'Blocked', value: '1', note: 'Held in onboarding', accent: 'red' },
  { label: 'Accepted', value: '2', note: 'In ongoing compliance', accent: 'green' }
];

export const handover_rows = [
  {
    ref: 'HO-2051',
    entity: 'Lulama Trading',
    journey: 'Supplier',
    landed_in: 'Supplier register',
    onboarding_risk: 'Low - 22',
    provisioned: '2/10',
    handoff_status: 'Pending review',
    handoff_status_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'handover_lulama_trading',
    highlighted: false
  },
  {
    ref: 'HO-2050',
    entity: 'Kabo Sithole',
    journey: 'Employee',
    landed_in: 'Employee register',
    onboarding_risk: 'Low - 14',
    provisioned: '9/9',
    handoff_status: 'Complete',
    handoff_status_class: 'bg-success-subtle text-success-emphasis',
    drawer_key: 'handover_kabo_sithole',
    highlighted: false
  },
  {
    ref: 'HO-2049',
    entity: 'Helios Mining',
    journey: 'Client',
    landed_in: 'Contract register',
    onboarding_risk: 'Medium - 48',
    provisioned: '8/8',
    handoff_status: 'Complete',
    handoff_status_class: 'bg-success-subtle text-success-emphasis',
    drawer_key: 'handover_helios_mining',
    highlighted: false
  },
  {
    ref: 'HO-2048',
    entity: 'ABC Tech Solutions',
    journey: 'Supplier',
    landed_in: 'Held at finance gate',
    onboarding_risk: 'High - 78',
    provisioned: 'Held',
    handoff_status: 'Blocked',
    handoff_status_class: 'bg-danger-subtle text-danger-emphasis',
    drawer_key: 'handover_abc_tech_solutions',
    highlighted: false
  },
  {
    ref: 'HO-2047',
    entity: 'NewGX Capital',
    journey: 'Partner',
    landed_in: 'Awaiting CEO (DoA-014)',
    onboarding_risk: 'Medium - 61',
    provisioned: '2/10',
    handoff_status: 'Pending review',
    handoff_status_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'handover_newgx_capital',
    highlighted: false
  },
  {
    ref: 'HO-2046',
    entity: 'BrightPay Merchant',
    journey: 'Merchant',
    landed_in: 'Supplier register',
    onboarding_risk: 'Medium - 39',
    provisioned: '2/10',
    handoff_status: 'Incomplete',
    handoff_status_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'handover_brightpay_merchant',
    highlighted: false
  }
];

export const obligation_rows = [
  { entity: 'ABC Tech Solutions', obligation: 'Obtain valid tax clearance', type: 'Document', due: 'Immediate', status: 'Overdue', status_class: 'bg-danger-subtle text-danger-emphasis', highlighted: false, drawer_key: 'obligation_abc_tax_clearance' },
  { entity: 'ABC Tech Solutions', obligation: 'Submit BBBEE certificate', type: 'Document', due: 'Immediate', status: 'Overdue', status_class: 'bg-danger-subtle text-danger-emphasis', highlighted: false, drawer_key: 'obligation_abc_bbbee_certificate' },
  { entity: 'ABC Tech Solutions', obligation: 'Re-run finance gate after documents', type: 'Review', due: 'On receipt', status: 'Blocked', status_class: 'bg-danger-subtle text-danger-emphasis', highlighted: false, drawer_key: 'obligation_abc_finance_gate' },
  { entity: 'NewGX Capital', obligation: 'CEO co-sign on reseller agreement', type: 'Approval', due: 'Immediate', status: 'Pending', status_class: 'bg-warning-subtle text-warning-emphasis', highlighted: false, drawer_key: 'obligation_newgx_ceo_cosign' },
  { entity: 'NewGX Capital', obligation: 'Conflict-of-interest mitigation', type: 'Review', due: 'On approval', status: 'Pending', status_class: 'bg-warning-subtle text-warning-emphasis', highlighted: false, drawer_key: 'obligation_newgx_conflict_mitigation' },
  { entity: 'Helios Mining', obligation: 'Cross-border transfer monitoring', type: 'Monitoring', due: 'Ongoing', status: 'Active', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_helios_cross_border' },
  { entity: 'Lulama Trading', obligation: 'Annual tax clearance refresh', type: 'Document', due: '30 Apr 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_lulama_annual_tax_refresh' },
  { entity: 'Lulama Trading', obligation: 'BBBEE re-verification', type: 'Document', due: '15 Mar 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_lulama_bbbee_reverification' },
  { entity: 'Lulama Trading', obligation: 'Supplier performance review', type: 'Review', due: '12 Nov 2026', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_lulama_supplier_performance' },
  { entity: 'Kabo Sithole', obligation: 'Annual conflict-of-interest re-declaration', type: 'Declaration', due: '12 May 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_kabo_conflict_redeclaration' },
  { entity: 'Kabo Sithole', obligation: 'Security-awareness refresher', type: 'Training', due: '12 May 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_kabo_security_refresher' },
  { entity: 'Helios Mining', obligation: 'Contract performance review', type: 'Review', due: '11 Nov 2026', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_helios_contract_review' },
  { entity: 'BrightPay Merchant', obligation: 'Submit insurance certificate', type: 'Document', due: '24 May 2026', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_brightpay_insurance_certificate' },
  { entity: 'BrightPay Merchant', obligation: 'Clear activation exception', type: 'Review', due: '24 May 2026', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'obligation_brightpay_clear_exception' }
];

export const renewal_rows = [
  { entity: 'ABC Tech Solutions', item: 'Tax clearance (renew first)', review_date: 'Immediate', expiry_date: '02 May 2026', status: 'Immediate', status_class: 'bg-info-subtle text-info-emphasis', highlighted: false, drawer_key: 'renewal_abc_tax_clearance_renew_first' },
  { entity: 'NewGX Capital', item: 'Tax clearance', review_date: '30 Jun 2026', expiry_date: '31 Jul 2026', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_newgx_tax_clearance' },
  { entity: 'Lulama Trading', item: 'BBBEE certificate', review_date: '15 Feb 2027', expiry_date: '15 Mar 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_lulama_bbbee_certificate' },
  { entity: 'BrightPay Merchant', item: 'Tax clearance', review_date: '28 Feb 2027', expiry_date: '31 Mar 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_brightpay_tax_clearance' },
  { entity: 'Lulama Trading', item: 'Tax clearance', review_date: '30 Mar 2027', expiry_date: '30 Apr 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_lulama_tax_clearance' },
  { entity: 'Kabo Sithole', item: 'Conflict declaration', review_date: '12 Apr 2027', expiry_date: '12 May 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_kabo_conflict_declaration' },
  { entity: 'Kabo Sithole', item: 'Security-awareness training', review_date: '12 Apr 2027', expiry_date: '12 May 2027', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_kabo_security_awareness' },
  { entity: 'BrightPay Merchant', item: 'Contract renewal', review_date: '10 Feb 2028', expiry_date: '10 May 2028', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_brightpay_contract_renewal' },
  { entity: 'Helios Mining', item: 'Contract renewal', review_date: '11 Feb 2028', expiry_date: '11 May 2028', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_helios_contract_renewal' },
  { entity: 'Lulama Trading', item: 'Contract renewal', review_date: '12 Feb 2029', expiry_date: '12 May 2029', status: 'Scheduled', status_class: 'bg-success-subtle text-success-emphasis', highlighted: false, drawer_key: 'renewal_lulama_contract_renewal' }
];

export const bridge_modules = [
  { label: 'Suppliers', route_name: 'SupplierRegister', icon: 'bi-box-seam' },
  { label: 'Employees', route_name: 'EmployeeRegister', icon: 'bi-people' },
  { label: 'Contracts', route_name: 'ContractLifecycle', icon: 'bi-file-earmark-text' },
  { label: 'Training', route_name: 'TrainingProgram', icon: 'bi-mortarboard' },
  { label: 'Conflicts of interest', route_name: 'ConflictsOfInterest', icon: 'bi-person-exclamation' },
  { label: 'Evidence vault', route_name: 'EvidenceVault', icon: 'bi-inboxes' },
  { label: 'Risk register', route_name: 'RisksDashboard', icon: 'bi-exclamation-triangle' },
  { label: 'Workflows', route_name: 'Workflows', icon: 'bi-diagram-3' },
  { label: 'My Tasks', route_name: 'MyTasks', icon: 'bi-list-check' },
  { label: 'Regulatory calendar', route_name: 'RegulatoryCalendar', icon: 'bi-calendar2-week' },
  { label: 'Reports', route_name: 'ReportsDashboard', icon: 'bi-graph-up' }
];

export const inbound_items = [
  { title: 'Evidence pack', copy: 'Every document collected to pass intake gates', route_label: 'Evidence vault', route_name: 'EvidenceVault', icon: 'bi-inboxes', icon_class: 'is-teal' },
  { title: 'Control satisfactions', copy: 'Which controls the activation already satisfies', route_label: 'Controls library', route_name: 'ControlsLibrary', icon: 'bi-shield-check', icon_class: 'is-blue' },
  { title: 'Risk score baseline', copy: 'Onboarding risk score and the reasons behind it', route_label: 'Risks', route_name: 'RisksDashboard', icon: 'bi-exclamation-triangle', icon_class: 'is-orange' },
  { title: 'Approval history', copy: 'Every approver, decision and timestamp at intake', route_label: 'DoA audit trail', route_name: 'DelegationOfAuthority', icon: 'bi-arrow-clockwise', icon_class: 'is-teal' },
  { title: 'Activation decision', copy: 'Activated by whom, when, under which template', route_label: 'Audit log', route_name: 'AuditsRegister', icon: 'bi-check2-circle', icon_class: 'is-teal' }
];

export const outbound_items = [
  { title: 'DoA thresholds', copy: 'Approval thresholds OnboardOS must enforce at intake', route_label: 'Delegation of authority', route_name: 'DelegationOfAuthority', icon: 'bi-diagram-3', icon_class: 'is-blue' },
  { title: 'Control requirements', copy: 'Evidence each journey must collect before activation', route_label: 'Controls library', route_name: 'ControlsLibrary', icon: 'bi-shield', icon_class: 'is-orange' },
  { title: 'Policy rules', copy: 'Mandatory training, conflict declarations, retention', route_label: 'Policies', route_name: 'CompliancePolicies', icon: 'bi-file-earmark-text', icon_class: 'is-teal' },
  { title: 'Re-onboarding triggers', copy: 'Annual refresh and expiry events that re-open a case', route_label: 'Calendar - Suppliers', route_name: 'RegulatoryCalendar', icon: 'bi-arrow-counterclockwise', icon_class: 'is-blue' }
];

export const document_rows = [
  create_document_row(1, 'ABC Tech Solutions', 'Supplier', 'BBBEE certificate', 'Not on file', '-', 'Missing', 'bg-danger-subtle text-danger-emphasis', false),
  create_document_row(2, 'BrightPay Merchant', 'Merchant', 'Insurance certificate', 'Outstanding - 14-day exception', '-', 'Missing', 'bg-danger-subtle text-danger-emphasis', false),
  create_document_row(3, 'ABC Tech Solutions', 'Supplier', 'Tax clearance (SARS)', 'Expired 02 May', '02 May 2026', 'Expired', 'bg-danger-subtle text-danger-emphasis', false),
  create_document_row(4, 'NewGX Capital', 'Partner', 'Reseller agreement', 'Awaiting co-sign', '-', 'Pending', 'bg-warning-subtle text-warning-emphasis', true),
  create_document_row(5, 'Lulama Trading', 'Supplier', 'Signed contract', 'MSA-2026-118', '12 May 2029', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(6, 'Lulama Trading', 'Supplier', 'Director declarations', '3 directors', '-', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(7, 'Kabo Sithole', 'Employee', 'Conflict-of-interest declaration', 'No conflict', '12 May 2027', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(8, 'Kabo Sithole', 'Employee', 'POPIA consent', 'Signed', '-', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(9, 'Kabo Sithole', 'Employee', 'Induction training', 'Completed', '12 May 2027', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(10, 'Helios Mining', 'Client', 'Beneficial-ownership declaration', 'Filed', '-', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(11, 'Helios Mining', 'Client', 'Cross-border mechanism', 'SCCs in place', '-', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(12, 'ABC Tech Solutions', 'Supplier', 'Signed contract', 'MSA-2024-061', '30 Jun 2026', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(13, 'NewGX Capital', 'Partner', 'Conflict declaration', 'Match flagged', '-', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(14, 'BrightPay Merchant', 'Merchant', 'Signed contract', 'MSA-2026-104', '10 May 2028', 'Received', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(15, 'Lulama Trading', 'Supplier', 'Tax clearance (SARS)', 'TCS-2026-4471', '30 Apr 2027', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(16, 'Lulama Trading', 'Supplier', 'CSD registration', 'MAAA-0091233', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(17, 'Lulama Trading', 'Supplier', 'BBBEE certificate', 'Level 2', '15 Mar 2027', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(18, 'Lulama Trading', 'Supplier', 'Banking confirmation', 'Std Bank - verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(19, 'Kabo Sithole', 'Employee', 'ID document', 'Verified - DHA', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(20, 'Kabo Sithole', 'Employee', 'Signed contract', 'EMP-2026-431', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(21, 'Kabo Sithole', 'Employee', 'Qualifications', '2 verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(22, 'Helios Mining', 'Client', 'Signed contract', 'CL-2026-077', '11 May 2028', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(23, 'Helios Mining', 'Client', 'Banking confirmation', 'Verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(24, 'ABC Tech Solutions', 'Supplier', 'CSD registration', 'MAAA-0801120', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(25, 'ABC Tech Solutions', 'Supplier', 'Banking confirmation', 'Verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(26, 'NewGX Capital', 'Partner', 'Tax clearance (SARS)', 'TCS-2026-3390', '31 Jul 2026', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(27, 'NewGX Capital', 'Partner', 'CSD registration', 'MAAA-0076451', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(28, 'NewGX Capital', 'Partner', 'Banking confirmation', 'Verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(29, 'BrightPay Merchant', 'Merchant', 'Tax clearance (SARS)', 'TCS-2026-2210', '21 Mar 2027', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(30, 'BrightPay Merchant', 'Merchant', 'CSD registration', 'MAAA-0051002', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false),
  create_document_row(31, 'BrightPay Merchant', 'Merchant', 'Banking confirmation', 'Verified', '-', 'Verified', 'bg-success-subtle text-success-emphasis', false)
];

const document_drawer_catalog = document_rows.reduce((catalog, row) => {
  catalog[row.drawer_key] = create_document_drawer(row);
  return catalog;
}, {});

const obligation_drawer_catalog = obligation_rows.reduce((catalog, row) => {
  catalog[row.drawer_key] = create_obligation_drawer(row);
  return catalog;
}, {});

const renewal_drawer_catalog = renewal_rows.reduce((catalog, row) => {
  catalog[row.drawer_key] = create_renewal_drawer(row);
  return catalog;
}, {});

export const drawer_catalog = {
  ...handover_drawer_catalog,
  ...document_drawer_catalog,
  ...obligation_drawer_catalog,
  ...renewal_drawer_catalog
};
